import DOMPurify from 'isomorphic-dompurify';

export const sanitizeForEmail = (
  input: string | number | undefined | null,
): string => {
  if (input === null || input === undefined) {
    return '';
  }

  const stringInput = String(input);

  if (!stringInput) {
    return '';
  }

  // DOMPurify with ALLOWED_TAGS: [] strips all HTML tags and encodes special
  // characters (>, &, <) to HTML entities (&gt;, &amp;, &lt;) by default.
  // This is the library's automatic behavior for security—treating plain text
  // as content and encoding special characters to prevent HTML interpretation.
  // Quotes and newlines are preserved as-is.
  const sanitized = DOMPurify.sanitize(stringInput, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true,
  });

  return sanitized;
};

export const sanitizeObjectForEmail = <T extends Record<string, any>>(
  obj: T,
): T => {
  const sanitized = {} as T;

  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (typeof value === 'string') {
      sanitized[key as keyof T] = sanitizeForEmail(value) as T[keyof T];
    } else if (
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value)
    ) {
      sanitized[key as keyof T] = sanitizeObjectForEmail(value) as T[keyof T];
    } else if (Array.isArray(value)) {
      sanitized[key as keyof T] = value.map((item) =>
        typeof item === 'string' ? sanitizeForEmail(item) : item,
      ) as T[keyof T];
    } else {
      sanitized[key as keyof T] = value;
    }
  });

  return sanitized;
};

export default sanitizeForEmail;
